<template>
    <div class="btn-group">
        <li @click="toggleMenu()" class="dropdown-toggle" v-if="selectedOption.name !== undefined">
          {{ selectedOption.name }}
          <span class="caret"></span>
        </li>

        <li @click="toggleMenu()" class="dropdown-toggle" v-if="selectedOption.name === undefined">
          {{placeholderText}}
          <span class="caret"></span>
        </li>

        <ul class="dropdown-menu" v-if="showMenu">
            <li v-bind:key="option.name" v-for="option in options">
                <a href="javascript:void(0)" @click="updateOption(option)">
                    {{option.name}}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
      data () {
        return {
          selectedOption: {
            name: ''
          },
          showMenu: false,
          placeholderText: 'Please select an item'
        }
      },
      props: {
        options: {
          type: [Array, Object]
        },
        selected: {},
        placeholder: [String]
      },

      mounted () {
        this.selectedOption = this.selected
        if (this.placeholder) {
          this.placeholderText = this.placeholder
        }
      },

      methods: {
        updateOption (option) {
          this.selectedOption = option
          this.showMenu = false
          this.$emit('updateOption', this.selectedOption)
        },

        toggleMenu () {
          this.showMenu = !this.showMenu
        }
      }
    }
</script>

<style>

.btn-group {
  width: 100%;
  height: 40px;
  position: relative;
  margin: 5px 1px;
  display: inline-block;
  vertical-align: middle;
}
.btn-group a:hover {
  text-decoration: none;
}

.dropdown-toggle {
  color: white;
  padding: 10px;
  min-width: 150px;
  text-transform: none;
  font-weight: 300;
  margin-bottom: 7px;
  border-bottom: 3px var(--sl-red) solid;
  transition: background 0s ease-out;
  float: none;
  box-shadow: none;
  border-radius: 0;
}
.dropdown-toggle:hover {
  background: rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.dropdown-menu {
  position: absolute;
  top: 50%;
  z-index: 1000;
    left: 50%;
   transform: translate(-50%, 0%);
   top: 50px;
  width: 200px;
  padding: 5px 0;
  margin: 2px 0 0;
  list-style: none;
  font-size: 28px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.377);
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-clip: padding-box;
}

.dropdown-menu > li > a {
  padding: 5px 20px;
  display: block;
  clear: both;
  font-weight: normal;
  line-height: 1.6;
  color: white;
  white-space: nowrap;
  text-decoration: none;
  border-left: 4px transparent solid;
  border-right: 4px transparent solid;
}
.dropdown-menu > li > a:hover {
  border-left: 4px var(--sl-red) solid;
  border-right: 4px var(--sl-red) solid;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
}

.dropdown-menu > li {
  overflow: hidden;
  width: 100%;
  position: relative;
  margin: 0;
}

.caret {
  display: relative;
  width: 0;
  position: relative;
  top: 10px;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  float: right;
}

li {
    list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Combo-Box.vue